import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/datawithSS.png'
import image2 from '../../images/traffic.png'
import image3 from '../../images/sus1.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/Netzence.png'
import { useEffect } from 'react'

function BlogPost8() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const blogs = [
    {
      id: 1,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "Netzence set to unveil clean mobility hailing App in June 2026",
      description: "At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...",
      source: "25/03/2026",
      image: image1,
      readMoreLink: "/blogpost"
    },
    {
      id: 2,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "2026 Climate Mobility Horizon: Nigeria’s New Income Engine  Netzence",
      description: "Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news...",
      source: "06/01/2026",
      image: image2,
      readMoreLink: "/blogpost4"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image3,
      readMoreLink: "/blogpost2"
    }
  ];

  return (
    <>
      <Header />

      {/* Return to blog */}
      <Link to="/blogs">
        <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 text-[14px] flex pt-20'>
          Return to blog
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </Link>

      {/* Title */}
      <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 text-[20px] sm:text-[22px] md:text-[24px] font-bold mt-2'>
        Nigeria can turn climate crisis into $9bn opportunity – Netzence
      </div>

      {/* Author row */}
      <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 flex gap-5 mt-10'>
        <img src={netzence} alt="netzence" className='w-[48px] h-[48px] object-contain flex-shrink-0' loading="lazy" />

        <div>
          <div className='text-[16px] mb-3'>
            Netzence
          </div>
          <div className='flex items-center gap-3 text-[14px] sm:text-[15px] md:text-[16px]'>
            July 3, 2025
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="3" r="3" fill="#898989"/>
            </svg>
            3 mins read
          </div>
        </div>
      </div>

      {/* Hero image */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:mr-72 xl:px-0'>
        <img src={sportlight} alt="spotlight" className='w-full max-w-[1200px] object-cover rounded-lg' loading="lazy" />
      </div>

      {/* Body content */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto">
          {/* Paragraph 1 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Netzence Sustainability Limited (Netzence) has said Nigeria can transform its social challenges into economic resilience by tapping into its CloseCarbon, a real-time carbon tracking and monitoring tool.</p>

          {/* Paragraph 2 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The organisation stated that given that the country grappled with severe climate challenges in 2024 as floods affected over 5.2 million people across 35 states, with 1,237 deaths and 1.2 million people displaced, CloseCarbon’s management solutions could transform these risks into rewards to secure a greener and prosperous future.</p>

          {/* Paragraph 3 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The organisation’s Chief Operations Officer, Ms Idia Okundaye said therein lay an opportunity for Nigeria to earn over $9 billion annually.</p>

          {/* Paragraph 4 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Okundaye said: “But what if Nigeria could turn these challenges into economic resilience, growth, and even leadership in the global green revolution? Within these crises lies an extraordinary opportunity for Nigeria to earn over $9 billion annually,” a figure that could triple by 2030 with the appropriate intervention. With CloseCarbon’s tracking and management solutions, Nigeria can transform risks into rewards, securing a greener, more prosperous future”.</p>

          {/* Paragraph 5 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
CloseCarbon leverages AI, data analytics, and blockchain to empower businesses, governments, and communities to measure, reduce, and offset carbon emissions. Its scalable platform provides real-time emissions tracking, facilitates carbon credit exchange, and promotes sustainable practices—tailored for Nigeria’s diverse needs, from smallholder farmers to industrial giants.</p>

          {/* Paragraph 6 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“This innovation aligns with Nigeria’s $177 billion Nationally Determined Contribution (NDC) goals for 2021–2030 and its $1.9 trillion Energy Transition Plan by 2060. By integrating advanced emissions tracking with localised adaptation strategies, CloseCarbon bridges the gap between Nigeria’s climate pledges and real-world impact.</p>

          {/* Paragraph 7 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Agriculture employs 35 per cent of Nigerians but is battered by floods, droughts, and rising temperatures. CloseCarbon’s AI tools optimize farming by recommending low-carbon practices like enhanced rock weathering (ERW), which boosts soil fertility while sequestering CO₂. Farmers can access carbon credit markets, turning sustainability into revenue—mitigating crop losses and food price spikes.</p>

          {/* Paragraph 8 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Powering a Green Energy Transition Nigeria’s energy sector, strained by heat-driven demand and costing businesses $29 billion annually, needs urgent reform.</p>

          {/* Paragraph 8 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
CloseCarbon tracks emissions from power generation, enabling solar, wind, and bioenergy projects to qualify for carbon credits. By integrating technologies like bioenergy with carbon capture and storage (BECCS), Nigeria can attract global investment, support its net-zero ambitions, and reduce its reliance on fossil fuels.</p>

          {/* Paragraph 8 */}
          <p className=" font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Source</p>

          {/* Paragraph 8 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full break-words" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
https://www.vanguardngr.com/2025/07/nigeria-can-turn-climate-crisis-into-9bn-opportunity-netzence/</p>

          {/* Paragraph 8 */}

          {/* Paragraph 12 */}

        </div>
      </div>

      {/* Related Blogs heading */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <h2
          className="text-[#0D924F] font-bold text-[26px] sm:text-[30px] md:text-[36px] leading-[1.2] md:leading-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

      {/* Related Blogs cards */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <div className='flex flex-col md:flex-row flex-wrap items-stretch justify-center md:justify-start gap-6 md:gap-8 mb-20'>
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="flex flex-col items-center pb-6 gap-4 w-full max-w-[379px] md:w-[379px] h-auto md:h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl mx-auto md:mx-0 md:shrink-0"
            >
              {/* Image */}
              <div className="w-full h-[220px] sm:h-[250px] md:h-[282px] rounded-t-2xl overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              {/* Article Content */}
              <div className="flex flex-col items-start gap-4 w-[90%] md:w-[352px] h-auto md:h-[222px]">
                {/* Badge */}
                <div
                  className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded max-w-full"
                  style={{ backgroundColor: blog.badgeColor }}
                >
                  <span
                    className="text-white font-medium text-[13px] md:text-[14px] leading-[21px] truncate"
                    style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                  >
                    {blog.badge}
                  </span>
                </div>

                {/* Text Container */}
                <div className="flex flex-col items-start gap-3 w-full">
                  {/* Title */}
                  <h3
                    className="text-[#3B3B3B] font-semibold text-[15px] sm:text-[17px] md:text-[20px] leading-[22px] md:leading-[24px] tracking-[-0.02em] w-full"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                    }}
                  >
                    {blog.title}
                  </h3>

                  {/* Description */}
                  <p
                    className="text-[#898989] font-normal text-[13px] md:text-[14px] leading-[20px] w-full"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontFeatureSettings: "'cv03' on, 'cv04' on"
                    }}
                  >
                    {blog.description}
                  </p>
                </div>

                {/* Footer */}
                <div className="flex flex-row justify-between items-center w-full">
                  <span
                    className="text-[#3B3B3B] font-normal text-[13px] md:text-[14px] leading-[21px]"
                    style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                  >
                    {blog.source}
                  </span>

                  <a
                    href={blog.readMoreLink}
                    className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                  >
                    <span
                      className="text-[#006633] font-medium text-[13px] md:text-[14px] leading-[20px]"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      Read More
                    </span>
                    <div className="relative w-2.5 h-4 flex items-center justify-center">
                      <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  )
}

export default BlogPost8